import { X_DISTANCE } from '..';
import { findFistNodesIds } from '@starflow/app/helpers/flow';
import { DEFNODE } from '../../../../../../constants';

export const FLOW_HEIGHT = 78; // 单节点高度（默认只带一个节点的高度，要根据实际句柄个数去计算单节点高度）
const NODE_PULLER = '0'; // 只是用于扁平结构转树状结构的根节点，无实际节点意义

// 遍历句柄个数
export const dealHanders = (nodes, edgeLists) => {
  const nodeMap = Object.fromEntries(nodes.map((item) => [item.id, item]));

  nodes.forEach((node) => {
    // 用于判断有多少个入口
    const targetEdgeNodeIds = edgeLists
      .filter((edge) => edge.target === node.id)
      // .map((item) => item.source)
      .filter(Boolean);

    node.data.targethandlers = targetEdgeNodeIds
      .map((edge) => ({ ...edge, sourceNode: nodeMap[edge.source] }))
      .filter((item) => !!item.sourceNode)
      .map((item) => {
        const targetNode = nodeMap[item.target];
        const inportPort = targetNode?.data?.inputs?.find((input) => input.name === item.targetHandle);
        if (!inportPort) {
          console.log('连接线异常', targetNode);
        }
        return {
          portLabel: inportPort?.label || '原图',
          targetPort: inportPort?.name || '',
          label: item.sourceNode.data.label,
          id: item.sourceNode.data.id,
        };
      });

    // 用于判断有多少个出口，目前只有单出
    const sourceEdgeNodeIds = edgeLists
      .filter((edge) => edge.source === node.id)
      .map((item) => item.target)
      .filter(Boolean);

    node.data.sourcehandlers = sourceEdgeNodeIds
      .map((sid) => nodeMap[sid])
      .filter(Boolean)
      .map((node) => ({ label: node.data.label, id: node.data.id }));

    // 目前默认都用一个样式的节点，后期要做diy，这里要增加对应nodetype
    node.type = DEFNODE;
  });

  return { nodes, edge_lists: edgeLists };
};

// 计算单条流中单条分支有多少个节点，终点是已经被统计过的节点
export const nodesInSingleLine = () => {};

// 根据单个节点的输入输出节点个数来决定最高高度
export const calcSingleNodeHeight = (edgeLists) => {
  let maxPortNumber = 0;
  edgeLists.forEach((edge) => {
    maxPortNumber = Math.max(edge.targetIndex ?? 0, maxPortNumber);
  });
  return FLOW_HEIGHT + maxPortNumber * 34; // 每一个节点都是按照最高节点的高度来展示
};

// 用于每个流节点的定位计算
export const dealLocation = ({ edge_lists, nodes }, col) => {
  const newNodes = [];
  const edgeLists = [...edge_lists];
  const singleNodeHeight = calcSingleNodeHeight(edgeLists);
  const beginIds = findFistNodesIds(edge_lists, nodes);
  beginIds.forEach((id, idx) => {
    let n = 0;
    let targetEdge = edgeLists.find((edge) => edge.source === id);
    let beforeEdge = {};
    while (targetEdge) {
      const node = nodes.find((node) => node.id === targetEdge.source);
      if (!node) return;
      if (newNodes.some((n) => n.id === node.id)) {
        // 如果下一个节点的位置在上一个节点A的位置同列，或者偏左，就把下一个节点的所有节点位置挪到A的下一列
        const {
          position: { x: b_x },
        } = nodes.find((node) => node.id === beforeEdge.source);
        const {
          position: { x: c_x, y },
        } = node;
        if (c_x <= b_x) {
          node.position = { x: b_x + X_DISTANCE, y };
        }
        let sourceNode = node;
        let curEdge = edgeLists.find((edge) => edge.source === sourceNode.id);
        while (curEdge) {
          let nextNode = nodes.find((node) => node.id === curEdge.target);
          if (!nextNode) return;
          nextNode.position = {
            x: sourceNode.position.x + X_DISTANCE,
            y: nextNode.position.y,
          };
          sourceNode = nextNode;
          curEdge = edgeLists.find((edge) => edge.source === sourceNode.id);
        }
      } else {
        node.position = { x: 0 + n * X_DISTANCE, y: 0 + idx * singleNodeHeight };
        newNodes.push(node);
      }
      const lastId = targetEdge.target;
      beforeEdge = JSON.parse(JSON.stringify(targetEdge));
      targetEdge = edgeLists.find((edge) => edge.source === targetEdge.target);
      n = n + 1;
      col.current = Math.max(col.current, n);
      if (!targetEdge && !newNodes.some((n) => n.id === lastId)) {
        const node = nodes.find((node) => node.id === lastId);
        if (!node) return;
        node.position = { x: 0 + n * X_DISTANCE, y: 0 + idx * singleNodeHeight };
        newNodes.push(node);
      }
    }
  });
  return { newNodes, edgeLists, rows: beginIds.length, singleNodeHeight };
};

// 找到一条流里面的最后一个节点
export const findEndNode = (edgelists = []) => {
  let rootId = '';
  edgelists.forEach((edge) => {
    const currId = edge.target;
    if (!edgelists.find((e) => e.source === currId)) {
      rootId = currId;
    }
  });
  return rootId;
};

// 将一条流的edge_list数据从扁平结构转换成树状
export const arrayToTree = (items) => {
  let res = [];
  let getChildren = (res, target) => {
    for (const i of items) {
      if (i.target === target) {
        const newItem = { ...i, children: [] };
        res.push(newItem);
        getChildren(newItem.children, newItem.source);
      }
    }
  };
  getChildren(res, NODE_PULLER); // 0 是只是用于树状结构的起点，方便递归，没有实际意义
  return res;
};

// 对树状结构的节点进行遍历，找出节点运行顺序数组
export const findQueue = (data, arr = []) => {
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    arr.push(item.source);
    if (item.children && item.children.length) {
      findQueue(item.children, arr);
    }
  }
  return arr;
};

export const findQueueList = (edgelists = []) => {
  const tree = arrayToTree([...edgelists.concat({ source: findEndNode(edgelists), target: NODE_PULLER })].reverse());
  return findQueue(tree).reverse();
};
